import axios from 'axios'

export default {
  // 克隆大作业
  cloneTask(params) {
    return axios.post('/api/rendering/admin/task/rendering/cloneTask', params)
  },
  // 校验旧版 SDK 提交的作业
  checkSdkMaxOldVersionTasks(params) {
    return axios.post('/api/rendering/admin/task/rendering/checkSdkMaxOldVersionTasks', params)
  },
  // 测试账号列表
  queryRdAccount() {
    return axios.post('/api/rendering/admin/task/rendering/queryRdAccount')
  },
}
